import { render, staticRenderFns } from "./already_insured.vue?vue&type=template&id=95a170dc&scoped=true"
import script from "./already_insured.vue?vue&type=script&lang=js"
export * from "./already_insured.vue?vue&type=script&lang=js"
import style0 from "./already_insured.vue?vue&type=style&index=0&id=95a170dc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95a170dc",
  null
  
)

export default component.exports